export const EVENT_CALENDAR_TYPES = {
  MONTH: 'month',
  DAY: 'day',
};
